var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarineCorps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29033",
    "data-name": "Group 29033",
    transform: "translate(-3969 4899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3969, -4899)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-marine-corps",
    transform: "translate(3986.002 -4885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50697",
    "data-name": "Path 50697",
    d: "M24.918,5.779C23.457,5.73,23.36,7.337,23.36,7.337s-.1.779-.779.779-.779-.779-.779-.779C21.8,5.535,21.071,5,20.243,5a1.829,1.829,0,0,0-1.558.779.763.763,0,0,0-.779.779h1.558v.779s-.1.779-.779.779-.779-.779-.779-.779-.1-1.607-1.558-1.558S7,10.453,7,10.453s.876,1.558,3.9,1.558,3.9-.779,3.9-.779a4.666,4.666,0,0,0,3.9,1.558c-.779.292-1.558,1.558-1.558,1.558a3.138,3.138,0,0,0,3.116,2.337h.779a3.137,3.137,0,0,0,3.116-2.337s-.779-1.266-1.558-1.558a4.666,4.666,0,0,0,3.9-1.558s.876.779,3.9.779,3.9-1.558,3.9-1.558S26.378,5.828,24.918,5.779Z",
    transform: "translate(-0.442 -0.663)",
    fill: "#dd9f05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50698",
    "data-name": "Path 50698",
    d: "M38.727,17a2.727,2.727,0,1,0,2.727,2.727A2.727,2.727,0,0,0,38.727,17Zm0,3.9A1.169,1.169,0,1,1,39.9,19.727,1.169,1.169,0,0,1,38.727,20.9Z",
    transform: "translate(-6.851 -3.315)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50699",
    "data-name": "Path 50699",
    d: "M31.341,26.906l-3.478-4.7L25.7,16.758,27.064,16l3.4,4.7,2.24,5.45ZM21.8,34.7s-3.847.341-5.453-.779a11.318,11.318,0,0,0,.779,3.116v2.337S21.022,38.007,21.8,34.7ZM13.232,19.9a11.516,11.516,0,0,0-1.558,5.453A12.415,12.415,0,0,1,9.337,23.79L7,23.011S7.925,19.9,13.232,19.9Z",
    transform: "translate(-0.442 -3.094)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50700",
    "data-name": "Path 50700",
    d: "M28.829,22.052c-.414.03-.918.06-1.478.13l-.9.1a.644.644,0,0,0-.416.182,3.682,3.682,0,0,1-.409.24l-8.3,4.553L12.139,30.1a2.536,2.536,0,0,1-3.023-2.647,6.872,6.872,0,0,1,.941-3.213l-1.72.1s-1.558.925-1.558,3.9c0,2.773,1.5,3.369-.338,6.341-.289.418-.441.67-.441.67s.392.011,1.057-.023c4.12.182,5.893,3.918,8.908,3.918h1.72l.812-1.915s-3.439.087-4.674-1.4a2.4,2.4,0,0,1-.033-3.068s0-.009,0-.012l5.033-2.76,8.3-4.553a3.723,3.723,0,0,1,.422-.216.642.642,0,0,0,.377-.253l.566-.7c.36-.435.657-.844.9-1.176.492-.667.754-1.085.754-1.085S29.657,22,28.829,22.052Z",
    transform: "translate(-0.221 -4.42)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50701",
    "data-name": "Path 50701",
    d: "M22.18,18a8.18,8.18,0,1,0,8.18,8.18A8.18,8.18,0,0,0,22.18,18Z",
    transform: "translate(-1.989 -3.536)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28992",
    "data-name": "Group 28992",
    transform: "translate(12.011 15.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50702",
    "data-name": "Path 50702",
    d: "M25.646,33.8a8.135,8.135,0,0,0,1.322-.779H17.391a8.135,8.135,0,0,0,1.322.779ZM15.222,30.685a8.079,8.079,0,0,0,.542.779H28.6a8.079,8.079,0,0,0,.542-.779ZM14,26.4c0,.132.013.259.019.39h16.32c.007-.13.02-.258.02-.39s-.013-.259-.019-.39H14.019C14.013,26.141,14,26.269,14,26.4Zm.243,1.948q.1.4.232.779H29.884a7.941,7.941,0,0,0,.232-.779Zm3.148-8.569h9.577A8.135,8.135,0,0,0,25.646,19H18.713A8.135,8.135,0,0,0,17.391,19.779Zm-1.627,1.558a8.079,8.079,0,0,0-.542.779H29.138a8.079,8.079,0,0,0-.542-.779Zm-1.289,2.337a7.942,7.942,0,0,0-.232.779H30.116q-.1-.4-.232-.779Z",
    transform: "translate(-14 -19)",
    fill: "#dd9f05"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50703",
    "data-name": "Path 50703",
    d: "M28.55,28.347a.645.645,0,0,1-.15.3,12.834,12.834,0,0,1-2.162,2.08c-.607.486-1.324,1.011-1.391,1.786-.029.339.054.744-.2.967-.218.189-.246.177-.442-.034a1.382,1.382,0,0,1-.294-.8,4.727,4.727,0,0,1,.125-1.724,4.17,4.17,0,0,0,.314-1.779c-.105-.563-.876-1.13-.827-1.7.018-.211.1-.448-.029-.618s-.395-.16-.608-.216c-.386-.1-.215-.618-.564-.813-.7-.39-2.181.061-2.645-.591-.254-.357-.1-1.511-.471-1.746s-.051.979-.454.779c-.48-.238-1.493-1.3-.909-1.817.4-.356.325-.763.325-1.3-.146-.39-1.173-.257-1.775-.13a8.156,8.156,0,0,1,5.733-2.956c.1-.007-.274.425.767,1.514a.453.453,0,0,1,.13.5c-.146.257-.538.059-.743-.153s-.6-.411-.743-.154a.454.454,0,0,0,0,.344,3.085,3.085,0,0,0,.442.928.555.555,0,0,0,.425.291c.231-.008.362-.259.532-.416a.813.813,0,0,1,1.293.521.69.69,0,0,1-.2.534,1.831,1.831,0,0,1-.38.237c-.738.42-.818.471-.544,1.274a.485.485,0,0,1-.58.163c-.206-.074-.048,0-.2-.163a2.024,2.024,0,0,0-.779,1.258c0,.237.686.2.9.3.692.329.35.779,1.79.779a6.451,6.451,0,0,1,1.9.178,4.354,4.354,0,0,1,2.278,1.961A.663.663,0,0,1,28.55,28.347Zm-4.94-10.286a6.443,6.443,0,0,0-.513.775.328.328,0,0,0,.1.26,1.949,1.949,0,0,0,.663.643.584.584,0,0,0,.559.038.663.663,0,0,0,.186-.227,6.238,6.238,0,0,0,.492-1.181A8.168,8.168,0,0,0,23.611,18.061Z",
    transform: "translate(-2.517 -3.544)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50704",
    "data-name": "Path 50704",
    d: "M29.152,17.781A.777.777,0,0,1,29.92,17a3.4,3.4,0,0,1,2.28.9,2.926,2.926,0,0,1,.827,2,1.161,1.161,0,0,1-1.587.909,5.7,5.7,0,0,0,.046-.693,1.452,1.452,0,0,0-1.556-1.558A.782.782,0,0,1,29.152,17.781Zm2.723,4.673a2.7,2.7,0,0,1-1.028-.2.832.832,0,0,1-.554.2c-.534,0-1.056-.086-1.565-1.122a7.99,7.99,0,0,0-2.267-2.6.779.779,0,0,0-.907,1.267,6.477,6.477,0,0,1,1.775,2.023,3.063,3.063,0,0,0,2.963,1.994,2.487,2.487,0,0,0,2.354-1.683A2.718,2.718,0,0,1,31.876,22.453ZM10.463,35.3A6.635,6.635,0,0,1,7.35,31a3.616,3.616,0,0,1,1.385-1.66,3.619,3.619,0,0,0,1.717-2.6A2.477,2.477,0,0,0,9.27,24.266a8.491,8.491,0,0,0-.375,2.473c0,.435-.563.907-1.159,1.407a11.461,11.461,0,0,0-.957.866,11.65,11.65,0,0,1-.217-1.885h0c0-.022,0-.041,0-.063,0-.155,0-.253,0-.262a1.329,1.329,0,0,1,.016-.171,5.262,5.262,0,0,1,.75-2.544A2.817,2.817,0,0,0,5,26.779a12.545,12.545,0,0,0,.808,4.465c.468,2.248,2.44,6.083,6.763,6.083a7.916,7.916,0,0,0,.8-.058C12.428,36.709,11.515,35.945,10.463,35.3Zm1.666-7.461a.857.857,0,0,1,.079-.11,8.232,8.232,0,0,1-.2-1.77,2.629,2.629,0,0,0-1.268,1.169c-.56,1.1-.209,2.531.946,4.327a18.528,18.528,0,0,1,1.68,2.945,2.828,2.828,0,0,0,.233.323,3.312,3.312,0,0,0,1.45.915c.4-1.727-1.246-3.821-2.068-5.048S11.856,28.382,12.128,27.84Z",
    transform: "translate(0 -3.315)",
    fill: "#c18706"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28993",
    "data-name": "Group 28993",
    transform: "translate(12.195 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50705",
    "data-name": "Path 50705",
    d: "M26.517,5.779c-1.461-.049-1.558,1.558-1.558,1.558s-.1.779-.779.779-.779-.779-.779-.779C23.4,5.535,22.67,5,21.842,5a1.829,1.829,0,0,0-1.558.779.763.763,0,0,0-.779.779h1.558v.779s-.1.779-.779.779-.779-.779-.779-.779-.1-1.607-1.558-1.558a14.85,14.85,0,0,0-3.711,1.558h3.711c0,2.012,2.337,2.337,2.337,2.337h3.9a2.289,2.289,0,0,0,2.337-2.337h3.711A14.85,14.85,0,0,0,26.517,5.779Z",
    transform: "translate(-14.236 -2.663)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50706",
    "data-name": "Path 50706",
    d: "M25.9,10.337c0,1.936-.872,4.674-1.948,4.674S22,12.273,22,10.337,22.872,8,23.948,8,25.9,8.4,25.9,10.337Z",
    transform: "translate(-15.952 -3.326)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50707",
    "data-name": "Path 50707",
    d: "M21.625,18.429l-.349-.7,1.414-.707.728-2.184.74.246-.83,2.49Z",
    transform: "translate(-15.792 -4.838)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50708",
    "data-name": "Path 50708",
    d: "M23,17.3h.779V18.86H23Zm3.331,1.127.349-.7-1.414-.707-.728-2.184-.74.246.83,2.49Z",
    transform: "translate(-16.173 -4.838)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50709",
    "data-name": "Path 50709",
    d: "M24.116,14.464H24.9v1.558h-.779Zm0-12.453a3.062,3.062,0,0,0-.534,0h-.245l-.016.031C22.4,2.184,21,2.784,21,5.127a1.547,1.547,0,0,1,1.558-1.558h5.066a2.8,2.8,0,0,0,1.988-.827L30.348,2Z",
    transform: "translate(-15.731 -2)",
    fill: "#ffc107"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineCorps);
export default __webpack_public_path__ + "static/media/marineCorps.142a6746695ddd2ea19a7b8813254bc9.svg";
export { ForwardRef as ReactComponent };